import { render } from "./ReviewConversation.vue?vue&type=template&id=05c60c74&scoped=true&name=review"
import script from "./ReviewConversation.vue?vue&type=script&lang=js"
export * from "./ReviewConversation.vue?vue&type=script&lang=js"

import "./ReviewConversation.vue?vue&type=style&index=0&id=05c60c74&scoped=true&lang=css"

import exportComponent from "/Users/lei.cao/Documents/PRIME_PreProc/ImageQC/SwipesForScience/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c60c74"]])

export default __exports__